const controleQualidade = [
    {
  "id": 1,
  "title":"Controle de qualidade",
   "descricao":"Um dos diferenciais das obras e empreendimentos da Cromo Construtora é o rígido controle de qualidade, dos insumos aos serviços de construção e infraestrutura. Adquirir um produto Cromo é garantia de investimento confiável, rentável e para a vida toda. ",
},

];
export default controleQualidade;